// Uyarı eşikleri: Platform Sahibi değiştirebilir (şifre doğrulamalı, alt/üst sınırlı)
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { ownerApi, apiError } from '../ownerApi';
import { ReauthDialog } from '../ReauthDialog';

const LABELS = {
  SLOW_P95: ['Yavaş P95 (ms)', 'Bu sürenin üstü "Uyarı"'], CRIT_P95: ['Kritik P95 (ms)', 'Bu sürenin üstü "Kritik"'],
  MIN_ROUTE_N: ['En az API isteği', 'Daha az örnekte teşhis/uyarı yok'], MIN_RUM_N: ['En az işlem ölçümü', 'Tarayıcı ölçümleri için'],
  ERR_PCT: ['Hata oranı (%)', '5xx oranı bu değerin üstünde'], SPIKE_X: ['Ani hata artışı (kat)', 'Olağan hata oranının kaç katı'],
  REGRESS_X: ['Performans düşüşü (kat)', 'Olağan P95 değerinin kaç katı'], REGRESS_MS: ['Performans düşüşü (en az ms)', 'P95 en az bu kadar artmalı'],
};

export const PerfThresholds = () => {
  const [rows, setRows] = useState(null);
  const [vals, setVals] = useState({});
  const [action, setAction] = useState(null);
  const load = () => ownerApi.get('/platform-owner/perf/thresholds').then(r => { setRows(r.data); setVals(Object.fromEntries(Object.entries(r.data).map(([k, v]) => [k, v.value]))); }).catch(e => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);
  const save = (pw) => ownerApi.put('/platform-owner/perf/thresholds', { password: pw, thresholds: vals })
    .then(() => { toast.success('Eşikler kaydedildi; sonraki analizde kullanılır'); setAction(null); load(); }).catch(e => toast.error(apiError(e)));
  if (!rows) return null;
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid="perf-thresholds">
      <div className="mb-3 flex items-center justify-between"><p className="font-semibold text-slate-900">Uyarı eşikleri</p>
        <Button size="sm" onClick={() => setAction({ title: 'Uyarı eşiklerini kaydet', description: 'Platform Sahibi şifrenizi girin.', confirmLabel: 'Kaydet', go: save })} data-testid="perf-thresholds-save">Kaydet</Button></div>
      <div className="grid gap-3 md:grid-cols-4">
        {Object.entries(rows).map(([k, r]) => (
          <label key={k} className="text-xs text-slate-600">{LABELS[k]?.[0] || k}
            <Input type="number" step="any" min={r.min} max={r.max} value={vals[k]} onChange={e => setVals(v => ({ ...v, [k]: e.target.value }))} className="mt-1" data-testid={`perf-threshold-${k}`} />
            <span className="text-[11px] text-slate-400">{LABELS[k]?.[1]} · varsayılan {r.default} · {r.min}–{r.max}</span>
          </label>))}
      </div>
      <ReauthDialog action={action} onClose={() => setAction(null)} onConfirm={(pw) => action.go(pw)} />
    </section>
  );
};
